import { ConvertStringToBoolean } from "../../../Helpers/Formatters/ConvertBoolean";
import TobaccoUsage from "../Helpers/TobaccoUsage";
import { heightFromString, numbersOnlyString } from "../../../Helpers/Conversion";
import { SESSION_STORAGE_ACCOUNT_KEY, getSessionStorageItem } from "../../../../sessionStorage";

const GeneratePrudentialHandoffRequest = (basicInfo, formData, submitRequest) => {
    const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
    const { email, firstName, lastName, phone, usResident, replacementIndicator, isReAttempt } = submitRequest;
    const gender = basicInfo.gender === 'M' ? 'male' : 'female';
    const tobacco = TobaccoUsage(basicInfo.tobacco);
    const height = heightFromString(basicInfo.height);
    const weight = numbersOnlyString(basicInfo.weight);
    const quoter = formData.quoter;

    const requestBody = {
        accountId: accountObj.account?.accountId,
        carrierID: quoter.selectedQuote.carrierID,
        oneClickAccountID: accountObj.account?.oneClickAccountId,
        sessionID: accountObj.sessionId,
        firstName: firstName,
        lastName: lastName,
        tobacco: ConvertStringToBoolean(tobacco),
        phone: phone.replace(/\D/g, ''),
        email: email,
        state: basicInfo.state,
        birthDate: basicInfo.birthdate,
        gender: gender,
        feet: height.heightFt,
        inches: height.heightIn,
        weight: weight,
        termPeriod: quoter.selectedQuote.termLength,
        quoteCoverageAmount: quoter.coverageAmount,
        monthlyPremiumAmount: quoter.selectedQuote.monthlyRate,
        healthClass: quoter.healthClass,
        isUsResident: ConvertStringToBoolean(usResident),
        isReplacement: ConvertStringToBoolean(replacementIndicator),
        isReAttempt: isReAttempt,
        quoteLogId: quoter.quoteLogId
    }
    return requestBody;
}

export {
    GeneratePrudentialHandoffRequest,
};